export const TESTNET_BINANCE_USDT_ADDRESS =
  "0xe51E8362805bE9e5317c14e54748Bf8638B118b7";
export const TESTNET_BINANCE_USDC_ADDRESS =
  "0x91f0E512B33595b41a9984EdE06335181dd065E2";
export const TESTNET_BINANCE_WBNB_ADDRESS =
  "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd";
export const TESTNET_BINANCE_WBTC_ADDRESS = "";
export const TESTNET_BINANCE_WETH_ADDRESS = "";

// Note: Tatum API headers/URLs removed — all Tatum calls are now made server-side only.

export const BNB_CHAIN_ID = "97";
export const ETH_CHAIN_ID = "11155111";
export const POLYGON_CHAIN_ID = "80002";

export const BTC_CHAIN_ID = "BTC";
export const TRON_CHAIN_ID = "TRON";

export const EVM_CHAIN_ID_LIST = [BNB_CHAIN_ID, ETH_CHAIN_ID, POLYGON_CHAIN_ID];
export const SESSION_TIMEOUT = 3000000; // 5 MIN session (300000)   
